<template>
  <transition name="fade" mode="out-in">
    <div id="select-ways-container-v2">
      <article class="select-v2-ways">
        <div class="select-v2-ways-wrapper">
          <h2 class="title-v2">{{ languages.plzSelectPayType }}</h2>
          <div class="ways-v2">
            <div
              class="onstore-way pay-way inner-pay"
              v-if="channelId == ONE_STORE"
              @click="startPayPage(GOOGLE_PAY)"
            ></div>
            <div
              class="google-way pay-way inner-pay j-google-way-dcount"
              v-else
              @click="startPayPage(GOOGLE_PAY)"
            >
              Google Play Store
            </div>
            <div
              class="third-way pay-way blue j-thrid-way-dcount"
              @click="skipPayPage"
            >
              官方平台儲值
            </div>
          </div>
        </div>
      </article>
    </div>
  </transition>
</template>

<script>
import bridge from '../../utiles/bridge';
import { LOGIN, PAGE_INIT } from '../../store/account';
import { LOAD_INIT_DATA, GET_LOGIN_STATUS } from '../../store/twStore';

import { storeHrefParam, setDefaultPrice } from '../../store/twStore/storager';
import globalConfig from '../../utiles/globalConfig';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const OTHER_TYPE = 'thirdType';
const GOOGLE_PAY = 'googlePay';
const GOOGLE_PLAY = 'googlePlay';
const ONE_STORE = 'oneStore';
const mainHost = globalConfig.getMainHost();
const imageMainHost = globalConfig.getImageMainHost();
export default {
  name: 'storeName',
  data() {
    return {
      OTHER_TYPE,
      GOOGLE_PAY,
      GOOGLE_PLAY,
      ONE_STORE,
      laddingFinish: false,
      channelId: globalConfig.getHrefParam('channelId'),
      brandTextUrl: `https://abres.octlib.com/platformIcon/storeLogoText/${imageMainHost}.png`
    };
  },
  computed: {
    discount() {
      let discount = '';
      let maxExtraRatio = this.$store.state.store.max_extra_ratio;
      let languages = this.$store.state.store.languages;
      if (maxExtraRatio < 0.02) {
        discount = languages.gainMorePlus;
      } else {
        discount = languages.gainMostPlus + maxExtraRatio * 100 + '%';
      }
      return discount;
    },
    languages() {
      return this.$store.state.store.languages;
    }
  },
  beforeCreate() {
    globalConfig.storeEntryParams();
    storeHrefParam();
    setDefaultPrice('');
    bridge.onReady(() => {
      this.$store.dispatch(PAGE_INIT).then(loginPath => {
        this.$store.dispatch(LOGIN, loginPath).then(() => {
          this.laddingFinish = true;
        });
      });
    });
  },
  methods: {
    startPayPage(type) {
      bridge.callSdkMethod('startPayPage', {
        way: type
      });
    },
    skipPayPage() {
      if (!this.laddingFinish) {
        return;
      }
      this.$store.dispatch(GET_LOGIN_STATUS).then(login => {
        if (!login) {
          this.doLogin();
        }
        this.$router.push('/pay');
      });
    },
    doLogin() {
      const twStoreHref = getGlobalGetGotoLink({ link: window.location.href });
      window.location.href =
        `https://pay.${mainHost}/platform/login.html?gameId=161&forward=` +
        encodeURIComponent(twStoreHref);
    }
  }
};
</script>
